import axiosInstance from "../libs/axiosInstance";

// Create a new topic
export const createTopic = async (topicData) => {
  try {
    const response = await axiosInstance.post('/course_management/topics/', topicData);
    return response.data;
  } catch (error) {
    console.error('Error creating topic:', error);
    throw error;
  }
};

// Get all topics
export const getAllTopics = async ({
  search_text=null, course_id=null, department_id=null, 
  faculty_id=null, level=null, with_quiz=null}={}) => {

  try {
    const params = {
      ...(search_text && { search: search_text }),
      ...(course_id && { course_id }),
      ...(department_id && { department_id }),
      ...(faculty_id && { faculty_id }),
      ...(level && { level }),
      ...(with_quiz && {with_quiz: 1})
    };
    const response = await axiosInstance.get('/course_management/topics/', {
      params
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching topics:', error);
    throw error;
  }
};

// Update a topic
export const updateTopic = async (topicId, topicData) => {
  try {
    const response = await axiosInstance.put(`/course_management/topics/${topicId}/`, topicData);
    return response.data;
  } catch (error) {
    console.error('Error updating topic:', error);
    throw error;
  }
};

export const getTopic = async (topicId) => {
  try {
    const response = await axiosInstance.get(`/course_management/topics/${topicId}/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching topics:', error);
    throw error;
  }
};

// Delete a topic
export const deleteTopic = async (topicId) => {
  try {
    await axiosInstance.delete(`/course_management/topics/${topicId}/`);
  } catch (error) {
    console.error('Error deleting topic:', error);
    throw error;
  }
};
